import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = ({ onLogin, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      setLoginError(error);
    }
  }, [error]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    setIsLoggingIn(true);
    try {
      const response = await fetch('https://lmssummarizer-edar.onrender.com/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      if (!response.ok) {
        throw new Error('Login failed');
      }
      const data = await response.json();
      onLogin(data.access_token);
      setUsername('');
      setPassword('');
    } catch (err) {
      setLoginError('Invalid username or password!');
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleBackToLanding = () => {
    navigate('/');
  };

  // Modal overlay and blur effect
  return (
    <div className="login-modal-overlay">
      <div className="login-modal-container">
        <button 
          type="button" 
          onClick={handleBackToLanding}
          className="back-button-top-left"
        >
          ✕
        </button>
        <form onSubmit={handleLogin} className="login-form">
          <div className="combined-logo d-flex align-items-center justify-content-center mb-1">
            <img src="/maia_logo_with_name.png" alt="Maia Icon" className="img-fluid me-2" style={{height: "42.5px"}} />
          </div>
          <div className="subtitle" style={{ color: '#fff', fontSize: '18px', fontWeight: 700, textAlign: 'center', marginBottom: 32 }}>
            Medical AI Assistant
          </div>
          <h3>Welcome</h3>
          <div className="error">{loginError || ""}</div>
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            placeholder="Please enter your username."
            value={username}
            onChange={e => setUsername(e.target.value)}
            disabled={isLoggingIn}
            required
            className={loginError ? 'input-error' : ''}
          />
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Please enter your password."
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={isLoggingIn}
            required
            className={loginError ? 'input-error' : ''}
          />
          <button type="submit" disabled={isLoggingIn}>
            {isLoggingIn ? (
              <span className="login-loading">
                <div className="spinner-small"></div>
              </span>
            ) : (
              'Login'
            )}
          </button>
          <div className="footer-row-login">
            <div className="copyright">© MAIA 2025</div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login; 